import { TbLambda } from "react-icons/tb";
import { GiConvergenceTarget } from "react-icons/gi";
import { IoIosLogIn } from "react-icons/io";
import {
    AiOutlineBlock,
    AiTwotoneTag,
    AiOutlineSolution,
    AiOutlineDollar
} from "react-icons/ai";
import { BsGlobeAmericas } from "react-icons/bs";
import { GoBook } from "react-icons/go";
import {
    LuPuzzle,
    LuShieldCheck,
    LuFlaskConical,
    LuAlignLeft,
    LuChartLine,
    LuChartBarIncreasing,
    LuGlasses,
    LuSquareActivity,
    LuNewspaper,
    LuScanLine,
    LuGauge
} from "react-icons/lu";

// Single source of truth for the marketing nav menu. Rendered by both the
// desktop USE CASES dropdown (ProductMarketingMenuv3) and the mobile drawer
// (MobileMarketingMenu) so labels, routes, and copy cannot drift apart.
export const MARKETING_MENU_CONFIG = {
    triggerLabel: "Use Cases",
    sections: [
        {
            href: "/use-cases/prep-the-data",
            icon: LuPuzzle,
            label: "Prep the Data",
            sublabel: "Unify GTM and Finance data. No ETL, no warehouse",
            roles: ["RevOps", "Data", "BI"],
            items: [
                {
                    href: "/products/next-gen-data-assembly",
                    icon: TbLambda,
                    iconProps: { strokeWidth: 2.5 },
                    label: "Data Assembly",
                    sublabel: "ETL-free data assembly that just works"
                },
                {
                    href: "/products/data-hygiene",
                    icon: LuShieldCheck,
                    iconProps: { strokeWidth: 2 },
                    label: "Data Hygiene",
                    sublabel: "Hygiene Agents run 24/7, plus tools for one-time cleanup"
                },
                {
                    href: "/products/multiple-crms",
                    icon: GiConvergenceTarget,
                    iconProps: { strokeWidth: 2 },
                    label: "Multi-Entity",
                    sublabel: "Multiple CRMs, ERPs, and billing → one source of truth"
                }
            ]
        },
        {
            href: "/use-cases/plan-the-growth",
            icon: LuFlaskConical,
            label: "Plan the Growth",
            sublabel: "Scenario and Deal Eval Agents build projections that show their work",
            roles: ["FP&A", "CFO", "CRO", "CMO"],
            items: [
                {
                    href: "/products/multi-quarter-projections",
                    icon: LuChartBarIncreasing,
                    iconProps: { strokeWidth: 2 },
                    label: "Growth Scenarios",
                    sublabel: "Rolling 0–36 month forecasts that bring teams together"
                },
                {
                    href: "/products/forecasting",
                    icon: LuGlasses,
                    iconProps: { strokeWidth: 2 },
                    label: "Sales Forecasting",
                    sublabel: "Deal Eval Agents + lightweight forecast submission orchestration"
                },
                {
                    href: "/products/revenue-forecasting",
                    icon: LuChartLine,
                    iconProps: { strokeWidth: 2 },
                    label: "Revenue Forecasting",
                    sublabel: "Translate bookings into recognized revenue across business models"
                },
                {
                    href: "/products/performance-drivers",
                    icon: LuSquareActivity,
                    iconProps: { strokeWidth: 2 },
                    label: "Performance Driver Analysis",
                    sublabel: "On-the-fly driver analysis, explainable and segment-by-segment"
                }
            ]
        },
        {
            href: "/use-cases/run-the-business",
            icon: LuAlignLeft,
            label: "Run the Business",
            sublabel: "QPilot and recipe agents run KPI reviews. Answers, not spreadsheets",
            roles: ["CRO", "CMO", "GTM Leaders"],
            items: [
                {
                    href: "/products/business-digest",
                    icon: LuNewspaper,
                    iconProps: { strokeWidth: 2 },
                    label: "Business Digests",
                    sublabel: "Monday-morning insights delivered where teams work"
                },
                {
                    href: "/products/qpilot",
                    icon: LuScanLine,
                    iconProps: { strokeWidth: 2 },
                    label: "AI Variance Analysis",  // FLAG: route is /products/qpilot — label and URL should converge
                    sublabel: "Daily agentic variance analysis with cited evidence"
                }
            ]
        },
        {
            href: "/use-cases/tell-the-story",
            icon: LuChartLine,
            label: "Tell the Story",
            sublabel: "Board-ready reporting packages from agents that compute, explain, and ship",
            roles: ["CEO", "Board"],
            items: [
                {
                    href: "/products/go-to-market-stats#gtm-reporting-packages",
                    icon: LuChartBarIncreasing,
                    iconProps: { strokeWidth: 2 },
                    label: "GTM Stats",
                    sublabel: "Core GTM stats for revenue waterfalls and reporting packages"
                },
                {
                    href: "/products/go-to-market-stats#core-stats",
                    icon: LuGauge,
                    iconProps: { strokeWidth: 2 },
                    label: "Core Efficiency Stats",
                    sublabel: "Rule of 40, NRR, magic number, CAC payback — defensible"
                }
            ]
        }
    ]
};

// Rendered only in the mobile drawer; desktop shows these in the nav bar itself.
export const MOBILE_SECONDARY_LINKS = [
    { href: "/login", icon: IoIosLogIn, label: "Sign in" },
    { href: "/solutions/finance", icon: AiOutlineDollar, label: "For Finance" },
    { href: "/solutions/revenue-operations", icon: AiOutlineSolution, label: "For RevOps" },
    { href: "/pricing", icon: AiTwotoneTag, label: "Pricing" },
    { href: "/partners", icon: AiOutlineBlock, label: "Partners" },
    { href: "/about", icon: BsGlobeAmericas, label: "About" },
    { href: "https://blog.qflow.ai", icon: GoBook, label: "Blog", external: true },
];
